class ReadMoreText extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-read-more-content]');
    this.button = this.querySelector('.read-more-text__button');

    if (!this.content || !this.button) return;

    this.limit = Number.parseInt(this.dataset.collapsedCharacters, 10);
    this.moreLabel = this.dataset.moreLabel || 'Lue lisää';
    this.lessLabel = this.dataset.lessLabel || 'Näytä vähemmän';
    this.originalNodes = Array.from(this.content.childNodes).map((node) => node.cloneNode(true));

    if (!Number.isFinite(this.limit) || this.content.textContent.trim().length <= this.limit) return;

    this.collapsedTextLength = this.findCollapsedTextLength(this.content.textContent, this.limit);
    this.expanded = false;
    this.button.hidden = false;
    this.button.addEventListener('click', this.toggle);
    this.collapse();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.toggle);
  }

  toggle = () => {
    if (this.expanded) {
      this.collapse();
    } else {
      this.expand();
    }
  };

  expand() {
    this.content.replaceChildren(...this.originalNodes.map((node) => node.cloneNode(true)));
    this.expanded = true;
    this.button.textContent = this.lessLabel;
    this.button.setAttribute('aria-expanded', 'true');
  }

  collapse() {
    let remainingCharacters = this.collapsedTextLength;
    const collapsedNodes = [];

    this.originalNodes.forEach((node) => {
      if (remainingCharacters <= 0) return;

      const truncatedNode = this.truncateNode(node, remainingCharacters);
      if (!truncatedNode) return;

      remainingCharacters -= truncatedNode.textContent.length;
      collapsedNodes.push(truncatedNode);
    });

    collapsedNodes.push(document.createTextNode('...'));
    this.content.replaceChildren(...collapsedNodes);
    this.expanded = false;
    this.button.textContent = this.moreLabel;
    this.button.setAttribute('aria-expanded', 'false');
  }

  findCollapsedTextLength(text, limit) {
    const normalizedText = text.trim();
    if (normalizedText.length <= limit) return normalizedText.length;

    const limitedText = normalizedText.slice(0, limit);
    const lastWhitespaceIndex = limitedText.search(/\s+\S*$/);

    return lastWhitespaceIndex > 0 ? lastWhitespaceIndex : limit;
  }

  truncateNode(node, remainingCharacters) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.trim() === '') return null;

      return document.createTextNode(node.textContent.slice(0, remainingCharacters));
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return null;

    const clone = node.cloneNode(false);

    Array.from(node.childNodes).forEach((childNode) => {
      if (remainingCharacters <= 0) return;

      const truncatedChild = this.truncateNode(childNode, remainingCharacters);
      if (!truncatedChild) return;

      remainingCharacters -= truncatedChild.textContent.length;
      clone.appendChild(truncatedChild);
    });

    return clone;
  }
}

if (!customElements.get('read-more-text')) {
  customElements.define('read-more-text', ReadMoreText);
}
